import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'whToKwh'
})
export class WhToKwhPipe implements PipeTransform {

  transform(value: number): number {
    return value / 1000;
  }

}